import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import { ACCESSIBILITY_TAGS } from "../constants/accessibility-tags";
import { CATEGORIES } from "../constants/categories";

@Component({
    selector: 'app-overview-filter-menu',
    templateUrl: './overview-filter-menu.component.html',
    styleUrls: ['./overview-filter-menu.component.css'],
    standalone: false
})
export class OverviewFilterMenuComponent implements OnInit {
  public inputValue: string = "";
  public typeValue: string = "";

  public eventTypes = CATEGORIES;
  public disabilityTypes = ACCESSIBILITY_TAGS;

  eventTypeArray: string[] = [];
  disabilityArray: string[] = [];

  screen_width!: number;
  hide_small!: boolean;

  @Output() closeDrawer = new EventEmitter<void>();
  @Output() inputValuesChange = new EventEmitter<{ inputValue: string, eventTypeArray: string[], disabilityArray: string[] }>();

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.onResize();

    this.route.queryParams.subscribe(params => {
      this.inputValue = params['query'];
      if (params['type']) {
        this.typeValue = params['type'];
      }

      if (this.eventTypes.some(category => category.tag === this.typeValue)) {
        this.toggleEventType(this.typeValue);
      } else {
        this.onInputChange();
      }
    });
  }

  onInputChange() {
    const emitValues = {
      inputValue: this.inputValue,
      eventTypeArray: this.eventTypeArray,
      disabilityArray: this.disabilityArray,
    }
    this.inputValuesChange.emit(emitValues);
  }

  toggleEventType(eventType: string) {
    if (this.eventTypeArray.includes(eventType)) {
      const index: number = this.eventTypeArray.indexOf(eventType);
      if (index !== -1) {
        this.eventTypeArray.splice(index, 1);
      }
    } else {
      this.eventTypeArray.push(eventType);
    }
    this.onInputChange();
  }

  closeFilterDrawer() {
    this.closeDrawer.emit();
  }

  toggleDisabilityType(disability: string) {
    if (this.disabilityArray.includes(disability)) {
      const index: number = this.disabilityArray.indexOf(disability);
      if (index !== -1) {
        this.disabilityArray.splice(index, 1);
      }
    } else {
      this.disabilityArray.push(disability);
    }
    this.onInputChange();
  }

  /**
   * Checks if the window size corresponds to one of the size limits
   *
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.screen_width = window.innerWidth;
    this.hide_small = this.screen_width <= 1500;
  }
}
